import * as React from "react";
import { Input, InputNumber, DatePicker,Tooltip,Select,Button } from 'antd';
import SmallTools from "widget/smallTools";
import moment from "moment";
import _ from "lodash";
const Option = Select.Option;


interface Data {
  contactInfo: any;
  data: any;
  updateDataValue :any;
  readonly:any;
  getTraveler?:any;
  orderDetails:any;
  ErrorInfo:any;
}

class contactInfo extends React.Component<Data> {
  state = {
    contactInfo:[],
    data:{},
    readonly:{},
    travelerData:[],
    isOpen:'shrink',
    openTitle:'展开',
    ErrorInfo:{},
  };

  constructor(props: Data) {
    super(props);
  }
  difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      });
    }
    return changes(object, base);
  }
  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(!nextProps.contactInfo){
      return false;
    }
    const keys = Object.keys(
      this.difference(nextProps.ErrorInfo, this.state.ErrorInfo)
    );
    if (prevState.contactInfo.length != nextProps.contactInfo.length || keys.length > 0) {
      this.setState({
        contactInfo: nextProps.contactInfo,
        data:nextProps.data,
        readonly:nextProps.readonly,
        ErrorInfo:nextProps.ErrorInfo,
      });
      if(nextProps.orderDetails['phone']){
        this.getTra(nextProps.orderDetails['phone']);
      }
      return false;
    }
    return true;
  }
  
  mapRadio = (list) =>{
      return(list.map((item) =>{
          return(<Option key={item}>{item}</Option>);
      }))
  }

  onChange = (id,value) =>{
    if(value instanceof Object){
       console.log(value.target.value)
       this.props.updateDataValue({id:id,value:value.target.value});
    }else{
       this.props.updateDataValue({id:id,value:value});
    }
  }

  onChangePinyin = (id,keys,items,value) =>{
    if(value instanceof Object){
       console.log(value.target.value)
       const itemlist = (items.map((item,key) =>{
           if(keys == key){
              return value.target.value;
           }else{
             return item;
           }
       }))
       this.props.updateDataValue({id:id,value:itemlist});
    }else{
       this.props.updateDataValue({id:id,value:value});
    }
  }
  changeOpen = () =>{
      if(this.state.isOpen == 'shrink'){
        this.setState({
          isOpen: 'open',
          openTitle:'收起',
        });
      }else{
        this.setState({
          isOpen:'shrink',
          openTitle:'展开',
        });      
      }
  }
  container=()=>{
    //console.log(document.getElementsByTagName("div"))
    return document.getElementsByTagName("div")[91]
 } 
  creatFrom = () => {
    const listItems = this.state.contactInfo.map((item, key) => {
      //let classTag = 'feild'+item['id'];
      switch(item['f_type']){
          case 'num':
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><InputNumber disabled={this.state.readonly[item['id']] ? true : false}  value={this.state.data[item['id']]} onChange={this.onChange.bind(this,item['id'])}  /></Tooltip></div></li>)
          case 'text':
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Input disabled={this.state.readonly[item['id']] ? true : false}  value={this.state.data[item['id']]} onChange={this.onChange.bind(this,item['id'])}  placeholder="" /></Tooltip></div></li>)
          case 'pinyin':
            return(
            <li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'>
            <Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}>
            <div className="xinming">
            <Input disabled={this.state.readonly[item['id']] ? true : false}  className="xin" value={this.state.data[item['id']][0]} onChange={this.onChangePinyin.bind(this,item['id'],0,this.state.data[item['id']])} placeholder=""  />
            <Input disabled={this.state.readonly[item['id']] ? true : false} className="ming" value={this.state.data[item['id']][1]} onChange={this.onChangePinyin.bind(this,item['id'],1,this.state.data[item['id']])} placeholder=""  />
            </div>
            </Tooltip>
            </div></li>
            )
          case 'number':
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Input disabled={this.state.readonly[item['id']] ? true : false}  value={this.state.data[item['id']]} placeholder="" onChange={this.onChange.bind(this,item['id'])}   /></Tooltip></div></li>)
          case 'calender':
            const Date = moment(this.state.data[item['id']],'YYYY-MM-DD HH:mm:ss');
            return( <li key={item['id']}><Tooltip placement="top" title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker disabled={this.state.readonly[item['id']] ? true : false}  value={Date} onChange={this.onChange.bind(this,item['id'])}   /></Tooltip></div></li>)
          case 'calendertime':
            if(this.state.data[item['id']] == ''){
              return( <li key={item['id']}><Tooltip placement="top" title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker disabled={this.state.readonly[item['id']] ? true : false}  showTime format="YYYY-MM-DD HH:mm:ss" onChange={this.onChange.bind(this,item['id'])}   /></Tooltip></div></li>)
            }else{
              const Datetime = moment(this.state.data[item['id']],'YYYY-MM-DD HH:mm:ss');
              return( <li key={item['id']}><Tooltip placement="top" title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker disabled={this.state.readonly[item['id']] ? true : false}  showTime format="YYYY-MM-DD HH:mm:ss" value={Datetime} onChange={this.onChange.bind(this,item['id'])}   /></Tooltip></div></li>)
            } 
          case 'radio':
            const options = this.mapRadio(item['rvalue']);
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Select disabled={this.state.readonly[item['id']] ? true : false}  showSearch optionFilterProp="children" >{options}</Select></Tooltip></div></li>);           
          default:
            return('')  
       }
      })

    return <React.Fragment>{listItems}</React.Fragment>;
  };

  selectTra = (key) => {
    const val = this.state.travelerData[key]; 
    this.props.updateDataValue({id:'2',value:val['name']}); 
    this.props.updateDataValue({id:'5',value:val['name_py']});
    this.props.updateDataValue({id:'9',value:val['phone']});
    this.props.updateDataValue({id:'13',value:val['foreign_phone']});
    this.props.updateDataValue({id:'15',value:val['email']}); 
    this.props.updateDataValue({id:'17',value:val['wechat']});
    this.props.updateDataValue({id:'19',value:val['qq']});          
  }

  getTraveler = () => {
    const listItems = this.state.travelerData.map((item,key) => {
          return(<Button key={key} className={key<4 ? 'open' : this.state.isOpen} onClick={this.selectTra.bind(this,key)} >{item['name']}</Button>)
    })
    if(this.state.travelerData.length > 4){
      listItems.push(<Button type="primary" onClick={this.changeOpen}>{this.state.openTitle}</Button>);
    }
    return <React.Fragment>{listItems}</React.Fragment>;
  }

 getTra = (phone) =>{
   const param: any = {
     phone:phone,
     type:'contacts'
   };
   this.props.getTraveler({
     ...param,
     callback: (data) => {
       this.setState({
         travelerData: data,
       });
     }
    });
  }

  render() {
    if(this.state.contactInfo.length == 0){
       return false;
    }else{
      return (
        <td>
        <div className='order-info'>
        <div className="used">
         {this.getTraveler()}
        </div>
        <ul>
        <SmallTools
            content={this.creatFrom()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
        />
        </ul>        
        </div> 
        </td>
      );
    }
  }
}
export default contactInfo;
